import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TablePagination,
  TableRow,
  Button,
} from "@mui/material";
import ScrollBar from "../../../components/Scrollbar";
import { useMutation, useQuery } from "@apollo/client";
import {
  ACTIVAR_REGISTRO,
  DESACTIVAR_REGISTRO,
  ELIMINAR_REGISTRO,
  OBTENER_PERSONAS,
} from "../../../graphql/personas";
import Iconify from "../../../components/Iconify";
import { FrmEditarPersona } from "../personas/index";
import MovimientosHeader from "../../../components/TableHeader/MovimientosHeader";
const TABLE_HEAD = [
  { id: "persona", label: "Nombre", alignRight: false },
  { id: "tipo", label: "Categoría", alignRight: false },
  { id: "", label: "", alignRight: false },
];
const PersonaTabla = ({
  setOpenDialog,
  setBodyDialog,
  setErrorGraph,
  setOpenSnackBar,
}) => {
  const { data, loading, error } = useQuery(OBTENER_PERSONAS);
  const [desactivarPersona] = useMutation(DESACTIVAR_REGISTRO, {
    update(cache, { data: { desactivarPersona } }) {
      const { obtenerPersonas } = cache.readQuery({
        query: OBTENER_PERSONAS,
      });
      cache.writeQuery({
        query: OBTENER_PERSONAS,
        data: {
          obtenerPersonas: [...obtenerPersonas, desactivarPersona],
        },
      });
    },
  });

  const [activarPersona] = useMutation(ACTIVAR_REGISTRO, {
    update(cache, { data: { activarPersona } }) {
      const { obtenerPersonas } = cache.readQuery({
        query: OBTENER_PERSONAS,
      });
      cache.writeQuery({
        query: OBTENER_PERSONAS,
        data: {
          obtenerPersonas: [...obtenerPersonas, activarPersona],
        },
      });
    },
  });

  const [eliminarRegistro] = useMutation(ELIMINAR_REGISTRO, {
    update(cache, { data: { eliminarRegistro } }) {
      const { obtenerPersonas } = cache.readQuery({
        query: OBTENER_PERSONAS,
      });
      cache.writeQuery({
        query: OBTENER_PERSONAS,
        data: {
          obtenerPersonas: [...obtenerPersonas, eliminarRegistro],
        },
      });
    },
  });

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  if (loading) {
    return <h1>cargando...</h1>;
  }
  const { obtenerPersonas } = data;
  //Longitud
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleActiveteRecord = async (e) => {
    try {
      const result = await activarPersona({
        variables: {
          id: e,
        },
      });

      setOpenSnackBar(true);
      setErrorGraph({
        mensaje: result.data.activarPersona,
        severity: "success",
      });
    } catch (error) {
      setOpenSnackBar(true);
      setErrorGraph({ mensaje: error.message, severity: "error" });
    }
  };

  const handleDeactivateRecord = async (e) => {
    try {
      const result = await desactivarPersona({
        variables: {
          id: e,
        },
      });

      setOpenSnackBar(true);
      setErrorGraph({
        mensaje: result.data.desactivarPersona,
        severity: "success",
      });
    } catch (error) {
      setOpenSnackBar(true);
      setErrorGraph({ mensaje: error.message, severity: "error" });
    }
  };

  const handleDeleteRecord = async (e) => {
    try {
      const result = await eliminarRegistro({
        variables: {
          id: e,
        },
      });

      setOpenSnackBar(true);
      setErrorGraph({
        mensaje: result.data.eliminarRegistro,
        severity: "success",
      });
    } catch (error) {
      setOpenSnackBar(true);
      setErrorGraph({ mensaje: error.message, severity: "error" });
    }
  };

  const handleEditData = (e) => {
    setBodyDialog(
      <FrmEditarPersona
        setOpenDialog={setOpenDialog}
        setErrorGraph={setErrorGraph}
        setOpenSnackBar={setOpenSnackBar}
        id={e}
      />
    );
    setOpenDialog(true);
  };
  return (
    <>
      <ScrollBar>
        <Table>
          <MovimientosHeader headLabel={TABLE_HEAD} />
          <TableBody>
            {obtenerPersonas
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => {
                const { id, nombre, apellidos, baja, CategoriaPersonasModel } =
                  row;
                return (
                  <TableRow hover key={id} tabIndex={-1}>
                    <TableCell>
                      {nombre} {apellidos}
                    </TableCell>
                    <TableCell>{CategoriaPersonasModel.categoria}</TableCell>
                    <TableCell>
                      <Button
                        value={id}
                        onClick={(e) => {
                          handleEditData(id);
                        }}
                        startIcon={<Iconify icon="eva:edit-2-outline" />}
                      >
                        Editar
                      </Button>
                      {baja ? (
                        <>
                          <Button
                            color="primary"
                            value={id}
                            startIcon={<Iconify icon="eva:checkmark-outline" />}
                            onClick={(e) => {
                              handleActiveteRecord(id);
                            }}
                          >
                            Activar
                          </Button>
                          <Button
                            value={id}
                            onClick={(e) => {
                              handleDeleteRecord(id);
                            }}
                            color="error"
                            startIcon={<Iconify icon="eva:close-outline" />}
                          >
                            Eliminar
                          </Button>
                        </>
                      ) : (
                        <Button
                          value={id}
                          onClick={(e) => {
                            handleDeactivateRecord(id);
                          }}
                          color="error"
                          startIcon={<Iconify icon="eva:close-outline" />}
                        >
                          Desactivar
                        </Button>
                      )}
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </ScrollBar>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        page={page}
        count={obtenerPersonas.length}
        rowsPerPage={rowsPerPage}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </>
  );
};

export default PersonaTabla;
